import { render, staticRenderFns } from "./CustomOriginSelector.vue?vue&type=template&id=5c5fbe42&scoped=true"
import script from "./CustomOriginSelector.vue?vue&type=script&lang=js"
export * from "./CustomOriginSelector.vue?vue&type=script&lang=js"
import style0 from "./CustomOriginSelector.vue?vue&type=style&index=0&id=5c5fbe42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fbe42",
  null
  
)

export default component.exports